<template>
  <div
    :class="['menu', `menu-${menu.id}`, {editable:selected}, {disabled:disabled},{'ui-hidden':hideGlobalUI},{'togo-menu':isTogoMenu}, menuClasses]"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"        
    v-toggle-select
    v-on-clickaway="deselect"
    ref="menu"
  >   
    <div class="menu-inner togo" ref="menuInner">
        <div v-if="!isTogoMenu" :class="['menu-col-left menu-col']">
          <div class="menu-title-wrap">
            <editable-text
              tag="div"
              :key="menu.acf.last_save_timestamp"
              class="menu-title"
              :content="menu.acf.menu_title? menu.acf.menu_title : 'no title'"
              :editable="isEditable"
              @update="menu.acf.menu_title = $event"
            />
          </div>
          <draggable
            v-model="menu.acf.sections"
            :class="['sections']"
            :options="{group:'menu-sections',draggable:'.section',disabled:!isAuthenticated}"
            @start="drag=true"
            @end="drag=false"
            @change="onRecurringSectionChange"
          >

            <menu-section
              v-for="(section, section_index) in menu.acf.sections"
              v-if="section.section_isRecurring"
              :section="section"
              :menu="menu"
              :key="section.section_uuid"
              @removeSection="removeSection"
              @itemDragStart="onItemDragStart"
              recurringSection            
            />

            <div class="section empty" v-if="!hasRecurringSections"></div>
          </draggable>

        </div>

        <div v-else-if="isTogoMenu" class="menu-title-wrap">
          <div class="menu-title">{{ menu.acf.menu_title? menuTitle : 'no title'}}</div>
        </div>

        <draggable
          v-model="menu.acf.sections"
          :class="['menu-col-right sections menu-col', {empty : !hasNonRecurringSections} ]"
          :options="{group:'menu-sections',draggable:'.section',disabled:!isAuthenticated}"
          @start="drag=true" @end="drag=false"
          ref="sections"
        >
          <menu-section
            v-for="(section, section_index) in menu.acf.sections"
            v-if="!section.section_isRecurring"
            :menu="menu"
            :section="section"
            :key="section.section_uuid"
            @removeSection="removeSection"
            @itemDragStart="onItemDragStart"
          />
   
        </draggable>

    </div> <!-- menu-inner -->
    <transition name="fade">
      <button-cluster
        v-if="selected || hovering"
        :buttons="buttons"
        :item="menu"
        bottomCenter
      />
    </transition>

<!--     <div v-if="menu.acf.footer_text" class="menu-board-footer-text">
      <editable-text
        tag="p"
        v-if="menu.acf.footer_text"
        :content="menu.acf.footer_text"
        :editable="isEditable"
        @update="menu.acf.footer_text = $event"
      />
    </div> -->
      
  </div>

</template>

<script>

import {mapState, mapGetters} from 'vuex'
import axios from 'axios'

import draggable from 'vuedraggable'
// import fitty from 'fitty'
import VueClickaway from 'vue-clickaway'
import ToggleSelect from '../../toggle-select'
import MenuMixin from './MenuMixin.js'
import ButtonCluster from '../UI/ButtonCluster'

import _reduce from 'lodash/reduce'
import _each from 'lodash/each'
import _isEqual from 'lodash/isEqual'
import _isEqualWith from 'lodash/isEqualWith'
import _cloneDeep from 'lodash/cloneDeep'
import _find from 'lodash/Find'

import moment from 'moment'

import EditableTextField from '../EditableTextField'
import MenuSection from './MenuSection'

export default {

  name: 'MenuBlock',
  mixins : [ VueClickaway.mixin, ToggleSelect, MenuMixin ],  
  props : [
    'menu',
    'numMenus',
    'menuOrder',
    'location'    
  ],
  components : {
    draggable,
    'menu-section' : MenuSection,
    'editable-text' : EditableTextField,
    'button-cluster' : ButtonCluster
  },
  computed : {
    hasRecurringSections() {
      return this.menu.acf.sections?
              this.menu.acf.sections.filter( section => section.section_isRecurring ).length :
              false;
    },
    hasNonRecurringSections() {
      return this.menu.acf.sections?
              this.menu.acf.sections.filter( section => !section.section_isRecurring ).length :
              false;
    },
    hasChanges() {
      // let diffs = this.getDiffKeys(this.menu.acf, this.originalACF)

      let acfChanges = !_isEqualWith(this.menu.acf, this.originalACF, this.isEqualCustomizer );
      return acfChanges;
    },
    isEditable() {
      return this.selected && !this.disabled && this.isAuthenticated;
    },
    isTogoMenu() {
      return parseInt( this.wpData.togo )
    }, // isTogoMenu
    ...mapState(['authToken','wpData']),
    menuTitle() {
      return this.menu.acf.menu_title.replace('\n', '')
    }, // menuTitle    
    ...mapGetters(['isAuthenticated'])    
  },
  methods: {

    getDiffKeys(a,b) {
      let diffs = _reduce(a, function(result, value, key) {
          return _isEqual(value, b[key]) ?
              result : result.concat(key);
      }, []);

      if( diffs.length ) {
        _each( diffs, key => {
          console.log(`a['${key}']`,a[key])
          console.log(`b['${key}']`,b[key])
          if( ![ typeof a[key], typeof b[key] ].includes("undefined") ) {
            this.getDiffKeys(a[key],b[key])
          }
        })
      }

      return diffs;            
    }, // getDiffKeys

    onItemDragStart() {
      this.selected = true;
    }, // onItemDragStart    
    onRecurringSectionChange( event ) {
      debugger;
      if( event.removed ) {
        let section = event.removed.element;
        section.section_isRecurring = false;
        this.menu.acf.sections.push( section )
      }
      if( event.added ) {
        let section = event.added.element;
        section.section_isRecurring = true;
        this.menu.acf.sections.push( section )
      }
      this.dragging = false;
    },

    onChoose(event) {
      this.dragging = true
    },

    addSection() {
      if( !this.menu.acf.sections) {
        this.menu.acf.sections = [];
      }

      let newSection = {
        // section_title : `menu ${this.numMenus+1} section ${this.menu.acf.sections.length+1}`,
        section_title : 'New Menu Section',
        section_uuid : Date.now() + this.numMenus,
        section_price_columns : [],
        items : []
      };

      this.menu.acf.sections.push(newSection);

    }, // addSection
    
    removeSection( section_id ) {
      this.menu.acf.sections = this.menu.acf.sections.filter(section=> section.section_uuid !== section_id )
    }, // removeSection


    clearChanges() {
      this.menu.acf = _cloneDeep(this.originalACF);
      this.menu.acf.last_save_timestamp = Date.now();
      this.deselect();
    }, // clearChanges


    saveMenu() {
      let acfChanges = !_isEqual(this.menu.acf, this.originalACF);
      if( !this.menu.new && !acfChanges ) {
        this.$notify('No changes were made');
        return true;
      }

      this.disableEdit();
      // this.$notify(`Saving single menu [${this.menu.id}]..`);
      this.$notify(`Saving ${this.menu.acf.menu_title} menu...`);

      this.$store.dispatch('authPromise').then( authToken => {

        let axiosCall = this.menu.new? this.newMenuPost() : this.updateMenuPost();

        return axiosCall.then(()=> {
          this.enableEdit();
          this.$notify({clean:true});
          this.$notify({text:'Done saving single menu', type:'success'});
          this.updateBirthday();
          // this.generatePDF();
        })
        .catch( (e) => {
          this.enableEdit();          
          this.$notify({clean:true});          
          this.$notify({text:'There was a problem saving!', type: 'warn'});
          console.log(e.response)
        });        

      }); // authPromise

    }, // saveMenu()


    newMenuPost() {

      return axios.post(
        `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}`,
        { status : 'publish', menu_order : this.menuOrder},
        { headers : {'Authorization' : `Bearer ${this.authToken}`} }

      ).then( res => {
        this.menu.id = res.data.id;
        this.menu.new = false;

        console.log(`[ New Menu Added ] ID ${this.menu.id}`,res);
        this.$notify(`[ New Menu Added ] ID ${this.menu.id}`);

        // Update add the WP Menu ACF meta
        let newMenuAcfs = this.updateMenuACF();
        return newMenuAcfs;
      });
      
    }, // newMenuPost()


    updateMenuPost() {
      let menu_id = this.menu.id;

      let menuUpdate;

      let menuData = {
        menu_order : this.menuOrder
      }

      menuUpdate = axios.post(
        `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}/${menu_id}`,
        menuData,
        { headers : {'Authorization' : `Bearer ${this.authToken}`} }
      ).then( res => {
        console.log(`[WP Post Updated for ${menu_id}]`,res)        
        this.$notify(`Updated menu id ${menu_id}`);
        return res;
      })

      // Update the WP Menu ACF meta
      let acfUpdate = this.updateMenuACF();

      return axios.all([menuUpdate, acfUpdate])
                .then( axios.spread( (menuRes,acfRes) => {
                  var resObj = {menuRes :menuRes, acfRes: acfRes};
                  console.log(`[Finished all for ${menu_id}]`,resObj)                  
                  return resObj;
                }));

    }, //updateMenuPost


    updateMenuACF() {

      // let acfChanges = !_isEqual(this.menu.acf, this.originalACF);
      // if( !acfChanges )
      //   return true;

      this.menu.acf.last_save_timestamp = this.phpTimestamp();

      let acfFields = { fields : this.menu.acf };
      return axios.put(
        `${this.wpData.rest_url}/acf/v3/${this.wpData.cpts.menuBlocks}/${this.menu.id}`,
        acfFields,
        { headers : {'Authorization' : `Bearer ${this.authToken}`} }
      ).then( res => {
        // this.$notify(`ACF Updated id ${this.menu.id}`);
        console.log(`[ACF Updated for ${this.menu.id}]`,res)
        this.originalACF = _cloneDeep(this.menu.acf);
        return res;
      });      
    }, // updateMenuACF()

    resetDeleteButton() {
      let deleteBtn = _find(this.buttons, btn => { return btn.title == this.confirmMsg; })
      deleteBtn.title = 'Menu';
      deleteBtn.icon = this.deleteIcon;
      deleteBtn.class = '';
      this.confirmDelete = false;
    }, // resetDeleteButton

    deleteConfirmationCheck() {
      let deleteBtn = _find(this.buttons, btn => { return btn.icon == this.deleteIcon; })
      deleteBtn.title = this.confirmMsg;
      deleteBtn.icon = false;
      deleteBtn.class = 'delete-confirmation';
      this.confirmDelete = true;
    }, // deleteConfirmationCheck

    deleteMenu() {
      if( !this.confirmDelete ) {
        this.deleteConfirmationCheck();
        this.confirmationTimeout = setTimeout( this.resetDeleteButton, 2000)
        return false;
      } else {
        clearTimeout(this.confirmationTimeout)
        let deleteBtn = _find(this.buttons, btn => { return btn.title == this.confirmMsg; })
        deleteBtn.title = 'Deleting...';
      }
      
      this.disableEdit();

      let menu_id = this.menu.id;

      console.log('[ Removing Menu... ]', this.menu );
      if( this.menu.new ) {
        this.$emit('removeMenu', menu_id);
      } else {

        // Delete from WP
        return this.$store.dispatch('authPromise').then( (authToken)=> {
          axios.delete(
            `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}/${menu_id}`,
            { headers : {'Authorization' : `Bearer ${authToken}`} }
          ).then( res => {
            console.log('[ Menu Deleted ]',res)
            this.$emit('removeMenu', menu_id);
          });
        });
      }
    }, // deleteMenu

    checkForUpdates() {      
      const fields = 'id,title,acf'; // retrieve data for specific fields only.

      const timestampURL = `${this.wpData.rest_url}/acf/v3/${this.wpData.cpts.menuBlocks}/${this.menu.id}/last_save_timestamp`;

      axios(timestampURL).then( res => {
        let dbTimestamp = res.data.last_save_timestamp;
        if( dbTimestamp > this.birthday ) {
          return this.fetchUpdates();
        }
      });
    }, // checkForUpdates

    fetchUpdates() {
      let menuPostPromise = axios(`${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}/${this.menu.id}/?fields=post_title`);
      let menuAcfPromise = axios(`${this.wpData.rest_url}/acf/v3/${this.wpData.cpts.menuBlocks}/${this.menu.id}`);

      return axios.all([menuPostPromise, menuAcfPromise])
                .then( axios.spread( (postRes,acfRes) => {
                  // this.$notify({title:`Refreshed ${this.menu.acf.menu_title} menu`, type:'success'});
                  console.log(`Refreshed ${this.menu.acf.menu_title} menu`);
                  console.log({post:postRes,acf:acfRes});

                  this.updateBirthday();

                  this.menu.acf = acfRes.data.acf

                  // this.$store.commit('refreshMenu', this.menu);

                  // this.$emit('refreshMenu', this.menu);
                }));
    }, // fetchUpdates

    phpTimestamp() {
      return Math.round( Date.now() / 1000 );
    }, // phpTimestamp

    updateBirthday() {
      this.birthday = this.phpTimestamp()      
    }, // updateBirthday

    isEqualCustomizer(objValue, otherValue, key) {
      if( key == "last_save_timestamp") {
        return true;
      }
    }, // isEqualCustomizer

    generatePDF() {
      debugger;
      let pdfData = this.wpData.pdfData;
      pdfData.timestamp = Date.now();
      axios
        .post('http://menus.joinresto.com/api', pdfData)
        .then( res => {
          console.log(res)
        })
    }, // generatePDF

    addTogoBodyClass() {
      let body = document.body
      let className = 'togo-body'
      if (body.classList)
        body.classList.add(className)
      else
        body.className += ' ' + className      
    }, // addTogoBodyClass

  }, // methods
  mounted() {},
  created() {
    this.originalACF = _cloneDeep(this.menu.acf); 
    if( parseInt( this.wpData.menu_board_id ) !== -1 ) {
      this.updateInterval = setInterval(this.checkForUpdates, 30 * 1000)
    }
    if( Number( this.wpData.togo ) ) {
      this.addTogoBodyClass()
    }

  },
  beforeDestroy() {
    clearInterval(this.updateInterval)
  },
  data () {
    return {
      images : [
        require('../../../static/citrus-segment.png'),
      ],
      confirmDelete : false,
      confirmMsg : 'You Sure?',
      deleteIcon : 'delete',      
      buttons: [
        {
          title : 'Undo All',
          icon : 'undo',
          // iconOnly : true,
          clickHandler : this.clearChanges,
          conditional : ()=>{return this.hasChanges;},
        },
        {
          title : 'Save',
          icon : 'save',
          iconOnly : true,
          clickHandler : this.saveMenu,
          conditional : ()=>{return this.hasChanges;},          
        },
        {
          title : 'Section',
          icon : 'add_circle',
          // iconOnly : true,
          // dragGroup : {
          //   name : 'item-addons',
          //   pull : 'false'
          // },
          clickHandler : this.addSection,
          // dragStartAction : this.addButtonDragStart,
          // dragEndAction : this.addButtonDragEnd,
          // dragChangeAction : this.addButtonDragChange,
        },
        {
          title : 'Menu',
          icon : 'delete',
          // iconOnly : true,
          clickHandler : this.deleteMenu,
        },        
        // {
        //   title : 'Refresh',
        //   icon : 'refresh',
        //   iconOnly : true,
        //   clickHandler : this.checkForUpdates,
        //   // dragStartAction : this.addButtonDragStart,
        //   // dragEndAction : this.addButtonDragEnd,
        //   // dragChangeAction : this.addButtonDragChange,
        // },
      ]
    }
  }
}

</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Menus/MenuBlock.vue